<template>
  <div ref="viewLabExpense" class="content-wrapper view-lab-expense p-0">
    <div class="content">
      <b-card>
        <h4><i class="fas fa-file-invoice-dollar"></i> จัดการค่าแลป</h4>
        <div class="mt-3">
          <b-row>
            <b-col cols="12" sm="2">
              <b-form-group
                label="ค้นหาจาก:"
              >
                <b-form-select
                  v-model="dateType"
                  class
                  @change="searchExpenseList"
                >
                  <b-form-select-option :value="0"
                    >วันที่บันทึก</b-form-select-option
                  >
                  <b-form-select-option :value="1"
                    >วันที่รับงาน</b-form-select-option
                  >
                  <b-form-select-option :value="2"
                    >วันที่คำนวนDF</b-form-select-option
                  >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="4">
              <b-form-group
                label="วันที่:"
                invalid-feedback="*กรุณาเลือกวันที่"
                :state="Boolean(dateRange[0] && dateRange[1])"
              >
                <date-picker
                  v-model="dateRange"
                  range
                  format="DD MMM YY"
                  :formatter="momentFormat"
                  :shortcuts="dateRangeShortcuts"
                  :disabled-date="notAfterToday"
                  placeholder="เลือกวันที่ต้องการค้นหา"
                  input-class="form-control"
                  @input="searchExpenseList"
                ></date-picker>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="2">
              <!-- {{ getDoctorList }} -->
              <b-form-group label="แพทย์:">
                <b-form-select
                  v-model="doctorId"
                  :options="getDoctorList"
                  value-field="uid"
                  text-field="fullName"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"
                      >แพทย์ทั้งหมด</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="2">
              <b-form-group label="สถานะ:">
                <b-form-select v-model="statusFilter">
                  <template v-slot:first>
                    <b-form-select-option :value="null">สถานะทั้งหมด</b-form-select-option>
                  </template>
                  <b-form-select-option
                    v-for="status in LAB_STATUS_LIST"
                    :key="status.value"
                    :value="status.value"
                  >
                    {{ status.label }}
                  </b-form-select-option>
                  <b-form-select-option value="cancelled">
                    ยกเลิก
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="2" class="d-flex align-items-end">
              <b-button block variant="primary" class="mb-3" @click="openLabItemModal">
                <i class="fas fa-plus"></i>เพิ่มแลป
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
          id="invoiceTable"
          ref="invoiceTable"
          hover
          small
          sort-icon-left
          sort-by="id"
          :sort-desc="true"
          head-variant="light"
          :fields="fields"
          :items="invoiceList"
        >
          <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>

          <template v-slot:cell(status)="row">
            <b-badge v-if="row.item.cancelDt" variant="danger">ยกเลิก</b-badge>
            <div v-else-if="row.item.isUpdating" class="text-center">
              <b-spinner small></b-spinner>
            </div>
            <b-dropdown
              v-else
              size="xs"
              :text="getStatusLabel(row.item.status)"
              :variant="getStatusVariant(row.item.status)"
              boundary="window"
            >
              <b-dropdown-item
                :active="row.item.status === null"
                @click="onInlineStatusChange(row.item, null)"
              >
                ไม่มีสถานะ
              </b-dropdown-item>
              <b-dropdown-item
                v-for="status in LAB_STATUS_LIST"
                :key="status.value"
                :active="row.item.status === status.value"
                @click="onInlineStatusChange(row.item, status.value)"
              >
                {{ status.label }}
              </b-dropdown-item>
            </b-dropdown>
          </template>

          <template v-slot:cell(button)="row">
            <b-button-group v-if="!row.item.cancelDt" size="xs" class="show-when-hovered">
              <b-button variant="outline-danger" @click="deleteItem(row.item)">
                <i class="fas fa-trash-alt"></i>
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="openLabItemModal(row.item)"
              >
                <i class="fas fa-edit"></i>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-card>
      <LabItemModal
        ref="labItemModal"
        @fetchExpenseList="searchExpenseList"
      ></LabItemModal>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import LabItemModal from "@/components/modal/LabItem";
import { LAB_STATUS_LIST, getLabStatusByValue } from "@/constants/labStatus";

import moment from "moment";

import { eventBus } from "../main";

export default {
  name: "LabExpense",
  components: {
    Dialog,
    Loading,
    LabItemModal,
  },
  data() {
    return {
      isLoading: false,
      statusFilter: null,
      LAB_STATUS_LIST,
      searchFilter: {
        fromCreationDate: null, //"2021-10-07"
        toCreationDate: null,
        fromRecDate: null,
        toRecDate: null,
        fromDfDate: null,
        toDfDate: null,
        uid: null,
        pateintId: null,
        invoiceNo: null,
        mlabId: null,
        mCompanyId: null,
      },
      doctorId: null,
      fields: [
        {
          key: "index",
          label: "",
        },
        {
          key: "creationDt",
          label: "วันที่บันทึก",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate",
        },
        {
          key: "recDate",
          label: "วันที่รับงาน",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate",
        },
        {
          key: "dfDate",
          label: "วันคำนวนDF",
          sortable: true,
          class: "narrow-spacing",
          formatter: "formatDate",
        },
        {
          key: "invoiceNo",
          label: "เลขที่ invoice",
          class: "narrow-spacing",
        },
        {
          key: "erpDocumentNo",
          label: "ERP Doc No",
          class: "narrow-spacing",
        },
        {
          key: "mLab",
          label: "งานแลป",
          class: "narrow-spacing",
          formatter(i) {
            return i?.nameTh;
          },
        },

        {
          key: "mCompanyLab",
          label: "ชื่อบริษัท",
          class: "narrow-spacing",
          formatter(i) {
            return i?.nameTh;
          },
        },
        {
          key: "patient",
          label: "ชื่อคนไข้",
          class: "narrow-spacing",
          formatter(i) {
            return i?.firstNameTh + " " + i?.lastNameTh;
          },
        },
        {
          key: "doctor",
          label: "ชื่อแพทย์",
          class: "narrow-spacing",
          formatter(i) {
            return i?.fullName;
          },
        },
        {
          key: "price",
          label: "ราคา(บาท)",
          class: "narrow-spacing text-right",
        },
        {
          key: "dfAmount",
          label: "หักแพทย์",
          class: "narrow-spacing text-right",
        },
        {
          key: "cfAmount",
          label: "หักคลินิก",
          class: "narrow-spacing text-right",
        },
        {
          key: "vatAmount",
          label: "VAT(บาท)",
          class: "narrow-spacing text-right",
        },
        {
          key: "status",
          label: "สถานะ",
          class: "narrow-spacing text-center",
        },
        {
          key: "button",
          label: "",
        },
      ],

      //date range picker
      dateType: 0,
      dateRange: [],
      isTableLoading: false,

      momentFormat: {
        //[optional] Date to String
        // stringify: (date) => {
        //   return date ? moment(date).format("LL") : "";
        // },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value).toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          return; // a number
        },
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getLabExpenseList: "moduleLab/getLabExpenseList",
      getLabCompanyList: "moduleLab/getLabCompanyList",
      getLabCompanyBy: "moduleLab/getLabCompanyBy",
      getDoctorList: "moduleUser/getDoctorList",

      getReportDateRange: "moduleReport/getReportDateRange",
      dateRangeShortcuts: "moduleMaster/getDateRangeShortcuts",
    }),
    invoiceList() {
      let list = this.getLabExpenseList;
      if (this.doctorId !== null) {
        list = list.filter((i) => i.uid === this.doctorId);
      }
      if (this.statusFilter === "cancelled") {
        list = list.filter((i) => i.cancelDt);
      } else if (this.statusFilter !== null) {
        list = list.filter((i) => !i.cancelDt && i.status === this.statusFilter);
      }
      return list.map((i) =>
        i.cancelDt ? { ...i, _rowVariant: "danger" } : i
      );
    },

    today() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      return today;
    },
  },
  watch: {},
  methods: {
    ...mapActions({
      fetchLabExpenseList: "moduleLab/fetchLabExpenseList",
      deleteLabExpenseItem: "moduleLab/deleteLabExpenseItem",
      fetchLabCompanyList: "moduleLab/fetchLabCompanyList",
      fetchLabProductList: "moduleLab/fetchLabProductList",
      updateLabStatus: "moduleLab/updateLabStatus",
    }),
    init() {
      this.dateRange = [
        new Date(this.today.getFullYear(), this.today.getMonth(), 1),
        this.today,
      ];
    },
    searchExpenseList() {
      this.isLoading = true;
      this.searchFilter = {
        fromCreationDate: null, //"2021-10-07"
        toCreationDate: null,
        fromRecDate: null,
        toRecDate: null,
        fromDfDate: null,
        toDfDate: null,
        // uid: null,
        // pateintId: null,
        // invoiceNo: null,
        // mlabId: null,
        // mCompanyId: null,
      };

      switch (this.dateType) {
        case 1:
          this.searchFilter = {
            ...this.searchFilter,
            fromRecDate: this.formatStartDateUtc(this.dateRange[0]),
            toRecDate: this.formatEndDateUtc(this.dateRange[1]),
          };
          break;
        case 2:
          this.searchFilter = {
            ...this.searchFilter,
            fromDfDate: this.formatStartDateUtc(this.dateRange[0]),
            toDfDate: this.formatEndDateUtc(this.dateRange[1]),
          };
          break;
        default:
          this.searchFilter = {
            ...this.searchFilter,
            fromCreationDate: this.formatStartDate(this.dateRange[0]),
            toCreationDate: this.formatEndDate(this.dateRange[1]),
          };
      }
      this.fetchLabExpenseList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        event: {
          ...this.searchFilter,
          includeCancel: true,
        },
      })
        .then((res) => {})
        .catch((err) => {
          console.error(err);
        })
        .finally((res) => {
          this.isLoading = false;
        });
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    formatStartDate(date) {
      return date ? moment(date).startOf("day").format() : null;
    },
    formatStartDateUtc(date) {
      return date ? moment(date).startOf("day").utc(true).format() : null;
    },
    formatEndDate(date) {
      return date ? moment(date).endOf("day").format() : null;
    },
    formatEndDateUtc(date) {
      return date ? moment(date).endOf("day").utc(true).format() : null;
    },

    deleteItem(item) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบค่าแลปนี้ ?",
        `คุณต้องการรายการค่าแลปนี้`
      ).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;

          this.deleteLabExpenseItem({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: item.id,
          })
            .then((res) => {
              this.searchExpenseList();
              this.$refs.Dialog.showToast("success", "ลบรายการเรียบร้อย");
            })
            .catch((err) => {
              console.error(err);
            })
            .finally((res) => {
              this.isLoading = false;
            });
        }
      });
    },
    openLabItemModal(item) {
      this.$refs.labItemModal.show(item);
    },
    notAfterToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0));
    },
    async onInlineStatusChange(item, newStatus) {
      if (newStatus === item.status) return;

      this.$set(item, "isUpdating", true);
      try {
        await this.updateLabStatus({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          labId: item.id,
          status: newStatus,
          note: ""
        });
        item.status = newStatus;
        this.$refs.Dialog.showToast("success", "อัปเดตสถานะเรียบร้อย");
      } catch (err) {
        console.error(err);
        this.$refs.Dialog.showToast("danger", "อัปเดตสถานะไม่สำเร็จ");
      } finally {
        this.$set(item, "isUpdating", false);
      }
    },
    setDefaultValue() {
      this.dateRange = [];
      this.dateType = 0;
      this.statusFilter = null;
    },
    getStatusLabel(status) {
      return getLabStatusByValue(status).label;
    },
    getStatusVariant(status) {
      return getLabStatusByValue(status).variant;
    },
  },
  mounted() {
    let clinicUrl = this.$route.params.clinicUrl;
    let branchUrl = this.$route.params.branchUrl;

    this.fetchLabCompanyList({
      clinicUrl,
      branchUrl,
    });
    this.fetchLabProductList({
      clinicUrl,
      branchUrl,
    });
    this.$nextTick();
    this.searchExpenseList();
  },
  updated() {},
  destroyed() {
    this.setDefaultValue();
  },
};
</script>

<style>
.btn-purple {
  background-color: #6f42c1;
  border-color: #6f42c1;
  color: #fff;
}
.btn-purple:hover,
.btn-purple:focus {
  background-color: #5a32a3;
  border-color: #5a32a3;
  color: #fff;
}
</style>
